<template>
  <el-dialog
    :title="dialogTitle"
    :visible="is_visible"
    :width="dialogWidth"
    :close-on-click-modal="false"
    class="dialog-import"
  >
    <div class="body" v-if="metaData.panels">
      <div v-for="panel in metaData.panels" :key="panel.subtext" class="core">
        <p class="core__label">{{ panel.title }}</p>
        <p class="core__text core__text--info">
          {{ panel.subtext }}
        </p>
        <FormButtons
          v-for="item in panel.buttons"
          :key="item.id"
          :buttons_menu="[[item]]"
          topPanel
          :module="moduleName"
          view-type="detail"
          class="button-import"
          @ClosePopup="$emit('cancel-callback')"
        ></FormButtons>
      </div>
    </div>
    <div slot="footer">
      <div class="footer">
        <div class="buttons">
          <Button
            v-for="button in metaData.bottom_buttons"
            :key="`button_${button.lbl}`"
            footer
            buttonSize="big"
            :buttonColor="button.colorVisualClass"
            :buttonText="button.lbl.value"
            @click="$emit('cancel-callback')"
          />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui';
import { mixin } from '@/utils/mixins';
import { store } from '@/store';
import FormButtons from 'Elements/Form/FormButtons';
import Button from 'Elements/Button/Button';
import { MODULE } from '@/utils/constants';

export default {
  components: {
    'el-dialog': Dialog,
    FormButtons,
    Button
  },
  mixins: [mixin],
  props: {
    title: String,
    moduleName: {
      type: String,
      default: MODULE.CANDIDATES_MODULE
    },
    is_visible: Boolean,
    metaData: { type: Object }
  },
  computed: {
    dialogWidth() {
      return store.state.dialog.size;
    },
    dialogTitle() {
      return this.metaData?.title?.main[0].lbl?.value || 'Импорт кандидатов';
    }
  }
};
</script>

<style lang="scss" scoped>
.el-dialog__wrapper.dialog-import {
  & ::v-deep .el-dialog {
    background: $white !important;
    margin-top: 15vh !important;
    padding: 0 !important;

    &__header {
      padding: 14px 24px !important;

      .el-dialog__title {
        font-size: 18px !important;
        line-height: 28px !important;
        color: $black-200;
        font-family: 'Roboto Medium';
        font-weight: 500;
      }
    }

    .el-dialog__headerbtn {
      display: none;
    }

    .body,
    .body .core {
      display: flex;
      gap: 16px;

      .core {
        flex-direction: column;
        padding: 16px;
        background: $black-20;
        border-radius: 4px;

        &__label,
        &__text {
          text-align: left;
        }

        &__label {
          font-size: 15px;
          line-height: 24px;
          color: $black-200;
          font-weight: 400;
        }

        &__text {
          font-size: 14px;
          line-height: 24px;
          color: $black-120;
          white-space: normal;
          word-break: normal;
        }

        .button-import {
          & > div,
          & > div > .el-button {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
